import { Text, Image, CardHeader, makeStyles, tokens } from '@fluentui/react-components';
import { customColors, customFonts } from '../../../../styles';
import { NexusAgent } from '../../../../domain/agents/models/Agent';
import { buildAvatarSrc } from '../../../utils/AvatarUtils';

const useStyles = makeStyles({
    header: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
    },
    cardHeader: {
        fontFamily: customFonts.TitleFont,
        color: customColors.protivitiDarkBlue,
        gap: '12px',
    },
    agentImage: {
        width: '80px',
        height: '80px',
        borderRadius: '15px',
    },
    agentTitle: {
        fontFamily: customFonts.TitleFont,
        color: customColors.summarizeButtonDarker,
        fontSize: '4.25rem',
        lineHeight: '1.28',
        fontWeight: tokens.fontWeightSemibold,
    },
    agentDescription: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '80%',
        marginBottom: tokens.spacingVerticalM,
        textAlign: 'center',
        wordWrap: 'break-word',
        fontSize: tokens.fontSizeBase400,
        color: customColors.protivitiDarkBlue,
    },
});

interface AgentOverviewHeaderProps {
    agent: NexusAgent | null;
}

const AgentOverviewHeader: React.FC<AgentOverviewHeaderProps> = ({ agent }) => {
    const styles = useStyles();

    return (
        <header className={styles.header}>
            <CardHeader
                className={styles.cardHeader}
                image={
                    agent && (
                        <Image
                            src={buildAvatarSrc(agent.providerType, agent?.agentIconUrl)}
                            alt={agent?.name}
                            className={styles.agentImage}
                        />
                    )
                }
                header={<Text className={styles.agentTitle}>{agent?.name}</Text>}
            />
            <Text className={styles.agentDescription}>{agent?.description}</Text>
        </header>
    );
};

export default AgentOverviewHeader;
